import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';

import { HOTKEYS } from '@/lib/hotkeys';
import { userStore } from '@/models/stores/index';
import { MentionList } from './MentionList';

export default {
  items: ({ query }: { query: string }) => {
    const users = userStore.all;

    // const hubPathId = location.pathname.split("/")[1];

    return [
      ...users
        .map((user) => ({
          id: user.id,
          label: `${user.first_name} ${user.last_name}`,
          name: `${user.first_name} ${user.last_name}`,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          type: 'user',
        }))
        .filter((user) => {
          const q = query.toLowerCase();
          return (
            user.first_name.toLowerCase().includes(q) ||
            user.last_name.toLowerCase().includes(q) ||
            user.username.toLowerCase().includes(q)
          );
        }),
      // ...deals
      //   .map((deal: Deal) => ({
      //     id: deal.id,
      //     name: getInformativeDealTitle({
      //       primaryCustomerFullName: deal.primary_customer.full_name,
      //       vehicle: deal.vehicle,
      //       primarySalesRep: deal.primary_sales_rep,
      //       secondarySalesRep: deal.secondary_sales_rep,
      //     }),
      //     type: "deal",
      //   }))
      //   .slice(0, 2),
    ];
  },

  render: () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reactRenderer: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let popup: any;

    return {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onStart: (props: any) => {
        if (!props.clientRect) {
          return;
        }

        reactRenderer = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: reactRenderer.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'top-start',
        });
      },

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onUpdate(props: any) {
        reactRenderer.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onKeyDown(props: any) {
        if (props.event.key === HOTKEYS.GLOBAL_UNFOCUS_OR_CLOSE) {
          popup[0].hide();

          return true;
        }

        return reactRenderer.ref?.onKeyDown(props);
      },

      onExit() {
        popup[0].destroy();
        reactRenderer.destroy();
      },
    };
  },
};
